export const geoCodes = state => state.getIn(['geoCodes', 'entities']);
export const geoCodeById = (state, id) => geoCodes(state).get(String(id));
export const geoCodesByIds = (state, ids) => ids.map(id => geoCodeById(state, id));
